// User Modals Index
export { default as AppointmentModal } from './AppointmentModal';
export { default as FindUHIDModal } from './FindUHIDModal';
export { default as MyAppointmentsModal } from './MyAppointmentsModal';
export { default as NearbyHospitalsModal } from './NearbyHospitalsModal';
export { default as PatientRegistrationModal } from './PatientRegistrationModal';
export { default as ServicesPricingModal } from './ServicesPricingModal';
